<template lang="pug">
  .content(v-if="action")
    h2.title.is-5
      icon-base(width="30" height="30" icon-name="info" iconColor="#0567b3")
        icon-poi
      | Caratterizzazione
      span(v-if="isLayers" @click="hiddenLayers()")
          icon-base(width="25" height="25" icon-name="Nascondi layer" iconColor="#0567b3")
            icon-eye-disabled
    section(class="characterization-list")
      ul
        li(v-for="(items, index) in characterization" :key="index" :class="{ 'active': index === selected }")
          h6(@click="select(index)")
            span.bullet.is-pulled-left.is-cirlce(:style="{backgroundColor: items.colore }")
            | {{ items.categoria }}
            span(v-if="items.item.length")
              span.is-cirlce(v-if="index === selected" class="is-pulled-right") -
              span.is-cirlce(v-else class="is-pulled-right") +
          characterization-item(:details="items.item")
</template>

<script>
import IconBase from '@/components/IconBase'
import IconPoi from '@/components/icons/IconPoi'
import IconEye from '@/components/icons/IconEye'
import IconEyeDisabled from '@/components/icons/IconEyeDisabled'
import CharacterizationItem from '@/components/CharacterizationItem'
export default {
  name: 'TheCharacterization',
  components: {
    IconBase,
    IconPoi,
    IconEye,
    IconEyeDisabled,

    CharacterizationItem
  },
  props: {
    action: {
      type: Object
    },
    idFase: {
      type: [String, Number]
    },
    configurator: {
      type: Array
    }
  },
  computed: {
    selectedActions () {
      return this.$store.getters.selectedActions(this.action)
    },
    characterization () {
      return this.configurator
    },
    characterizationConfigurator () {
      return this.$store.getters.characterizationConfigurator
    },
    map () {
      return this.$store.state.map
    },
    webCartLayer () {
      return this.$store.state.webCartLayer
    },
    isLayers () {
      return this.characterizationConfigurator.some(i => i.item.some(l => {
        if (!l.hidden) {
          return true
        } else {
          return false
        }
      }))
    },
    visibleLayers () {
      let layers = []
      this.webCartLayer.allSublayers.map(sublayer => {
        if (sublayer.visible) {
          layers.push(sublayer.title)
        }
      })
      return layers
    }
  },
  data () {
    return {
      selected: null
    }
  },
  mounted: function () {
    this.init()
  },
  methods: {
    init () {
      if (this.action) {
        this.$store.dispatch('LOAD_CONFIG').then(results => {
          this.$store.dispatch('LOAD_CHARACTERIZATION_CONFIGURATOR', {id: this.action['Azioni.idAzione'], config: results})
        })
      }
      this.$store.commit('SET_MAXIMIZE')
    },
    select (index) {
      this.selected = this.selected === index ? null : index
    },
    hiddenLayers () {
      this.webCartLayer.allSublayers.forEach(sublayer => {
        // console.log('sublayer', sublayer.sublayers)
        // II layer padri restano visibili
        // se il layer ha sublayer li lascio visibili
        if (sublayer.sublayers) {
          sublayer.visible = true
        } else {
          sublayer.visible = false
        }
      })
      this.$store.commit('SET_TOGGLE_CHARACTERIZATION', {remove: true})
    }
  }
}
</script>

<style lang="scss" scoped>
h2.title {
  padding: 1em 0 1.1em 2em;
  background-color: lighten($background, 22%);
  margin-top: -.2em;
  margin-bottom: 2em;
  color: $link;
  font-weight: 300;
  svg {
    margin-right: .5em;
    margin-bottom: -6px;
  }
  span {
    cursor: pointer;
    float: right;
    margin-right: 1em;
  }
}

.characterization-list {
  list-style: none;
  margin-left: 0;
  ul {
    margin-left: 0;
    margin-bottom: 0em;
    margin-top: 0;
    & > li {
      border-bottom: 1px solid #e6e6e6;
      margin-top: 0;
      margin-bottom: .06em;
      overflow: hidden;
      max-height: 3.625em;
      transition: max-height 0.15s ease-out;
      &.active {
        max-height: 1000em;
        transition: max-height 0.25s ease-in;
      }
    }
  }

  h6 {
    cursor: pointer;
    height: 4em;
    margin-bottom: 0.6em;
    padding: 1em 1em 1em 2em;
    color: #333333;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    span.is-cirlce {
      width: 26px;
      height: 26px;
      text-align: center;
      margin-right: 0.7rem;
      font-size: 1.3em;
      line-height: 0.7;
      border-radius: 100%;
      border: 1px solid #8e8e8e;
      color: #8e8e8e;
      padding: 4px 6px;
      &.bullet {
        width: 13px;
        height: 13px;
        padding: 0;
        border: 0;
        margin-top: .15em;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/TheCharacterization.vue